import { render, staticRenderFns } from "./BaseFrame.vue?vue&type=template&id=32539376&scoped=true&"
import script from "./BaseFrame.vue?vue&type=script&lang=js&"
export * from "./BaseFrame.vue?vue&type=script&lang=js&"
import style0 from "./BaseFrame.vue?vue&type=style&index=0&id=32539376&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32539376",
  null
  
)

export default component.exports